import React from 'react'
import styles from './style.module.scss'

export const ContentLoader = ({width, height, spaceBetween, className}) => {
  return (
    <div
      className={`${styles['content__loader']} ${className ? className : null}`}
      style={{
        width,
        height,
        margin: spaceBetween || spaceBetween === "true" ? "0 15px" : "0"
      }}
    ></div>
  )
}